module.exports = __webpack_public_path__ + "img/walletDark.fb4ed435.svg";